// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"9e1f67b4","637":"31d6cfe0","650":"ec023c07","827":"17634755"}[chunkId] + ".chunk.css";
};